import React, { Component } from 'react';
import AudioAnalyser from 'react-audio-analyser';
import $ from 'jquery';
import { toggleSubmitActive } from '../../../../redux/testPage/testPage.actions';
import { setResetCounter } from '../../../../redux/utilities/utils.actions';
import { handleBlobChange } from '../../../../redux/utilities/utils.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { stopAllAudio, enableAudio } from '../../../../utils/commonFunctions';
import Loader from '../../../../utils/Loader';

class AudioRecorder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: '',
			audioSrc: '',
			isMicPermitted: false,
		};
		this.controlAudio = this.controlAudio.bind(this);
		this.audioStopTimeout = undefined;
		this.audioRecordStartTime = 0
		this.audioRecordDurationTime = 0
	}

	controlAudio(status) {
		this.setState({
			status,
		});
	}

	componentWillUnmount() {
		clearTimeout(this.audioStopTimeout)
	}

	render() {
		const { status, audioSrc } = this.state;

		const {
			clozeConvo,
			resetCounter,
			resetCounters,
			index,
			handleBlobChange,
			toggleSubmitActive,
			updateCounters,
			updateCounter,
			qtype,
		} = this.props;

		const audioProps = {
			// audioOptions: { sampleRate: 44100, channels: 1, kbps: 128 },
			audioOptions: { sampleRate: 16000, channels: 1, kbps: 16 },
			status,
			audioSrc,
			width: 640,
			height: 60,
			strokeColor: '#063B63',
			backgroundColor: '#5BBFB3',
			audioType: 'audio/webm',
			audioBitsPerSecond: 16000,
			// timeslice: 1000,
			startCallback: (e) => {

				this.audioRecordStartTime = Date.now()

				let timeoutAudio = (localStorage.getItem('active_course_id') === '688' || localStorage.getItem('active_course_id') === '693' || localStorage.getItem('active_course_id') === '686' || localStorage.getItem('active_course_id') === '683') ? 14000 : 45000;

				if (qtype.toLowerCase() == 'ielts' || qtype == 'IELTS') {
					this.audioStopTimeout = setTimeout(function () {

						if (!!index) {
							$(`.audioRecorder[index!=${index}] .icon-stop`).click();
						} else {
							$(`.audioRecorder .icon-stop`).click();
						}
					}, 120000);
				} else {
					this.audioStopTimeout = setTimeout(function () {

						if (!!index) {
							$(`.audioRecorder[index!=${index}] .icon-stop`).click();
						} else {
							$(`.audioRecorder .icon-stop`).click();
						}
					}, timeoutAudio);
				}

				stopAllAudio();
				$(`.audioRecorder[index=${index}]`).closest('.speaking-question').focus();
				if (typeof index !== 'undefined') {
					let recorders = $(`.audioRecorder[index!=${index}] .icon-stop`);

					for (var i = 0, len = recorders.length; i < len; i++) {
						recorders[i].click();
					}
				}
			},
			pauseCallback: (e) => {
				console.log('succ pause', e);
			},
			stopCallback: (e) => {
				Loader.show();
				clearTimeout(this.audioStopTimeout)

				let durTime = Date.now() - this.audioRecordStartTime
				this.audioRecordDurationTime = (durTime - (durTime % 1000)) / 1000;

				if (!!resetCounter) {
					updateCounter();
				} else if (!!resetCounters && resetCounters.length > 0) {
					updateCounters(index);
				}

				this.setState({
					audioSrc: window.URL.createObjectURL(e),
				});

				handleBlobChange({ blob: e, index });

				//added for individual reset
				if (clozeConvo) {
					if ($('.converse-nil')) {
						$('.converse-nil').focus();
					}
				} else {
					if (qtype.toLowerCase() === 'wordcloud') {
						if (!$('.arrange-words-inposition span').hasClass('avail'))
							toggleSubmitActive(false);
					} else if (qtype.toLowerCase() === 'cloze_with_passage') {
						if (!$('.quiz-area-options span').hasClass('to-be-filled'))
							toggleSubmitActive(false);
					} else toggleSubmitActive(false);
				}
				if (!$('.icon-stop').is(':visible')) {
					enableAudio();
				}
				Loader.hide();

				console.log('audio succ stop ', e);

				const _audioCont = document.getElementsByClassName("audioContainer")

				for (var ai = 0; ai < _audioCont.length; ai++) {
					let _audio = _audioCont[ai].querySelector("audio")
					if (_audio && _audio.src === this.state.audioSrc) {
						_audio.preload = true
						_audio.currentTime = _audio.currentTime === 0 ? this.audioRecordDurationTime : 0
						setTimeout(() => {
							_audio.currentTime = 0
						}, 1000)
					}
				}

			},
			onRecordCallback: (e) => {
				console.log('recording', e);
			},
			errorCallback: (err) => {
				console.log('error', err);
			},
		};
		return (
			<div>
				<div className="audioRecorder" index={index}>
					<div key={resetCounters[index]} className="btn-box">
						{status !== 'recording' && (
							<button
								aria-label="start-recording"
								onClick={() => this.controlAudio('recording')}
								className={`iconfont icon-start icon-start_cloze icon_start_${index} `}
							></button>
						)}
						{status === 'recording' && (
							<button
								aria-label="stop-recording"
								className="iconfont icon-stop"
								onClick={() => this.controlAudio('inactive')}
							></button>
						)}
					</div>
				</div>

				<AudioAnalyser
					style={{ width: '60px', height: '60px' }}
					{...audioProps}
				></AudioAnalyser>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { resetCounter, resetCounters },
		leftSectionProps: { qtype },
		questionNo,
		isMicPermitted,
	} = state.rootReducer.testPageDetails;

	return {
		resetCounter,
		resetCounters,
		questionNo,
		isMicPermitted,
		qtype,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSubmitActive: (val) => dispatch(toggleSubmitActive(val)),
		setResetCounter: (val) => dispatch(setResetCounter(val)),
		handleBlobChange: ({ blob, index }) =>
			dispatch(handleBlobChange({ blob, index })),
	};
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(AudioRecorder);
